<template>
  <div>
    <v-btn
      fab
      right
      bottom
      fixed
      class="btn-salvar-mobile"
      v-if="isMobile()"
      color="primary"
      title="Salvar dados"
      @click="salvarDados()"
      :loading="atualizandoVisita"
      ><v-icon>mdi-content-save</v-icon></v-btn
    >
    <v-btn v-else block color="success" @click="salvarDados()" >Salvar</v-btn>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {  
  computed: mapState("visitaTecnica",["atualizandoVisita"]),
  methods: {
    ...mapActions("visitaTecnica",["atualizarVisita"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async salvarDados(){
      var ret = await this.atualizarVisita()
      if(ret) this.$router.go(-1)
    }
  },
};
</script>

<style>
.btn-salvar-mobile {
  margin-bottom: calc(env(safe-area-inset-bottom) + 0px) !important;
}
</style>